// src/hooks/usePresence.js

import { useEffect } from 'react';
import { rtdb, auth } from '../config/firebase';
import { ref, onValue, set, onDisconnect, serverTimestamp } from 'firebase/database';

export const usePresence = () => {
  useEffect(() => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    const myStatusRef = ref(rtdb, 'status/' + currentUser.uid);

    // Reference to the special '.info/connected' path in Realtime Database
    const connectedRef = ref(rtdb, '.info/connected');

    const unsubscribe = onValue(connectedRef, (snap) => {
      if (snap.val() === true) {
        // If we're connected, set our status to online.
        set(myStatusRef, {
          state: 'online',
          last_changed: serverTimestamp(),
        });

        // When we disconnect, update our status to offline
        onDisconnect(myStatusRef).set({
          state: 'offline',
          last_changed: serverTimestamp(),
        });
      }
    });

    // Cleanup function
    return () => {
      unsubscribe();
      // Optional: set status to offline when the hook unmounts (e.g., user logs out)
      set(myStatusRef, {
        state: 'offline',
        last_changed: serverTimestamp(),
      });
    };
  }, []);
};